.vc-open-external-icon {
    transform: rotate(45deg);
}

.vc-owner-crown-icon {
    color: var(--status-warning);
}

.vc-heart-icon {
    margin-right: 0.5em;
    translate: 0 2px;
}
